<!--天澄定制历史示值-->
<template>

  <!-- 新历史示值 -->
  <div class="tcHistoryShowValue">
    <!--  -->

    <div :class="['new-tree',{'new-tree-active':!isShow}]">
      <div style="display: flex;padding-top:10px;align-items: center;">
        <el-input placeholder="输入关键字进行过滤" v-model="filterText" size="small" style='width: 180px;margin-left: 15px;'>
        </el-input>
      </div>
      <div class="elTree_hideButton1" v-show="isShow" @click="isShow=!isShow">
        <el-button size="mini" icon="iconfont iconleft_shousuo"></el-button>
      </div>
      <div class="elTree_hideButton2" v-show="!isShow" @click="isShow=!isShow">
        <el-button size="mini" icon="iconfont iconrigth_shousuo"></el-button>
      </div>

      <div class="scroll">
        <el-scrollbar style="height:95%;width: 100%;">
          <el-tree :data="virtualDeviceList" :default-expanded-keys="[2]" default-expand-all
            :expand-on-click-node="true" node-key="pkid" :props="defaultProps" :highlight-current='true'
            :filter-node-method="filterNode" ref="tree" @node-click="nodeClick">
            <span class="custom-tree-node" slot-scope="{node, data}">
              <img src="../../../public/static/image/elTree/1.9.png"
                v-show="node.data.type=='group'&&node.data.unitid!=''" />
              <img src="../../../public/static/image/elTree/2.0.png"
                v-show="node.data.type=='group'&&node.data.unitid==''" />
              <img src="../../../public/static/image/elTree/2.1.png" v-show="node.data.type=='virtualDevice'" />
              <span style="padding:0px  5px;">{{node.label }}</span>
            </span>
          </el-tree>
        </el-scrollbar>
      </div>
    </div>
    <div class="VirtualDeviceRTValueRigth">
      <!-- 头部选择功能 -->
      <div class="buttonLine">
        <label style="margin-left:10px;">日期：</label>
        <el-date-picker value-format="timestamp" size="small" v-model="datetimeValue" type="datetimerange"
          :picker-options="pickerOptions" range-separator="至" start-placeholder="开始时间"
          end-placeholder="结束时间"></el-date-picker>
        <iconButton @buttonClick='exportReport' buttonText='导出' icoName="wedoButton/download.png"></iconButton>
        <div class="totalPower">
          <p>合计：{{totalPower}} kWh</p>
        </div>
      </div>
      <!-- 表格显示数据 -->
      <el-table height="94%" :data="tableList" border highlight-current-row
        :header-cell-style="{background:'#F5F5F5',color:'#696969'}">
        <template slot="empty">
          <span class="noData">
            <img src="../../assets/noData.png" alt="暂无数据">
            <span class="text">暂无数据</span>
          </span>
        </template>
        <el-table-column type="index" width="90" label="序号"></el-table-column>
        <el-table-column v-for='item in columns' :prop="item.key" align='center' :label="item.name" :key="item.key"
          sortable></el-table-column>
      </el-table>
      <!-- <div style="width: 98%;display: flex;align-items: center;justify-content: flex-end;height: 5%;">
				<el-pagination
				@current-change='nowIndex = $event - 1'
				:page-size="pageLen"
				layout="total, prev, pager, next, jumper"
				:total="dataList.length">
				</el-pagination>
			</div> -->
    </div>
  </div>
</template>

<script type="text/javascript">
  import treeBody from '@/components/module/slotModule/treeBody.vue'
  import virtualDeviceTree from '@/components/module/tree/virtualDeviceTree.vue'
  import datePicker from '@/components/module/universal/datePicker.vue'
  import iconButton from '@/components/module/universal/iconButton.vue'
  import dateButton from '@/components/module/universal/dateButton.vue'
  import tcHistoryShowValueStore from '@/cache/tcHistoryShowValueStore.js'
  import elCheckBoxTree from '@/components/module/tree/elCheckBoxTree.vue'
  import historyApi from '@/components/api/historyApi.js'
  export default {
    components: {
      treeBody,
      virtualDeviceTree,
      dateButton,
      datePicker,
      iconButton,
      elCheckBoxTree
    },
    props: [],
    data () {
      return {
        isShow: true,
        tableList: [],
        filterText: '',
        bgDate: new Date(new Date(new Date().setDate(new Date().getDate()-1)).toLocaleDateString()),
        endDate: new Date(new Date().toLocaleDateString()),
        nowIndex: 0,
        totalPower: 0,
        nowCheckedItemName: '',
        columns: [{
          name: '采集点',
          key: 'deviceName'
        },{
          name: '应用类型',
          key: 'appTypeName'
        },{
          name: '起始示值',
          key: 'beginValue'
        },{
          name: '结束示值',
          key: 'endValue',
        },{
          name: '倍率',
          key: 'coefficient',
        },{
          name: '电量（kWh）',
          key: 'value'
        }],
        defaultProps: {
          children: 'next',
          label: 'name'
        },
        datetimeValue: [new Date(new Date().toLocaleDateString()).getTime()-3600*1000*24,new Date(new Date().toLocaleDateString()).getTime()],
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end=new Date(new Date().toLocaleDateString());
              const start=new Date(new Date().toLocaleDateString());
              start.setTime(start.getTime()-3600*1000*24*7);
              picker.$emit('pick',[start,end]);
            }
          },{
            text: '最近一个月',
            onClick (picker) {
              const end=new Date(new Date().toLocaleDateString());
              const start=new Date(new Date().toLocaleDateString());
              start.setTime(start.getTime()-3600*1000*24*30);
              picker.$emit('pick',[start,end]);
            }
          }]
        },
      }
    },
    created () {
      debugPage=this
    },
    mounted () {
      // this.$dialogMethod.showLoading('正在加载')
      this.RefreshList()
    },
    beforeDestroy () {
      tcHistoryShowValueStore.commit('clear')
    },
    computed: {
      /* virtualDeviceList() {
        var data = this.$store.deviceStore.getters.getReadDeviceTree
        return isempty(data) ? [] : [deviceList(data)]
      }, */
      virtualDeviceList () {
        var data=this.$store.deviceStore.getters.getReadDeviceTree

        return isempty(data)? []:[data]
      },
      historyShowValues () {
        return tcHistoryShowValueStore.state.historyShowValues
      },
      formData () {
        return tcHistoryShowValueStore.state
      },
      pageLen () {
        return this.dataList.length<20? this.dataList.length:20
      },
      nowPage () {
        // 按照页码来返回当前应该显示的列表
        var list=this.dataList.filter((item,index) => {
          return index>=this.nowIndex*this.pageLen&&index<(this.nowIndex+1)*this.pageLen
        })
        this.$dialogMethod.closeLoading()
        return list
      },
      dataList () {
        var total=0
        if(!isempty(this.historyShowValues)) {
          let power=this.historyShowValues.filter(item => {
            return item.appTypeName=="总"&&!isempty(item.value)
          })
          if(!isempty(power)) {
            power.map((item,index) => {
              total+=item.value
              this.totalPower=copy(cutDigital(total))
            })
          } else {
            this.totalPower='- -'
          }
        } else {
          this.totalPower='- -'
        }
        var result=this.historyShowValues.sort(this.compare('deviceName'))
        return result
      }
    },
    watch: {
      filterText (val) {
        this.$refs.tree.filter(val);
      },
      datetimeValue (nv,ov) {
        tcHistoryShowValueStore.commit('setbeginTime',nv[0])
        tcHistoryShowValueStore.commit('setendTime',nv[1])
        tcHistoryShowValueStore.commit('searchHistoryIndicationValue')
        this.$dialogMethod.showLoading('正在加载')
      },
      nowIndex () {
        this.nowPage
      }
    },
    methods: {
      //新历史示值以下
      filterNode (value,data) {
        if(!value) return true;
        return data.name.indexOf(value)!==-1;
      },
      nodeClick (value,nodeData) {
        var str=""
        var deviceNosStr=""
        if(value.type=="group") {
          var recursiveFunction=function() {
            const getStr=function(list) {
              list.forEach(function(row) {
                if(row.type=="group") {
                  getStr(row.next)
                } else {
                  str+=","+row.no
                }
              })
            }
            getStr(value.next)
          }
          recursiveFunction()

          deviceNosStr=str.slice(1)
        } else {
          deviceNosStr=value.no
        }
        this.getList(deviceNosStr)



      },
      RefreshList () {

        var str=""
        var virtualDeviceList=this.virtualDeviceList
        this.defaultPkid=virtualDeviceList[0].pkid
        var recursiveFunction=function() {
          const getStr=function(list) {
            list.forEach(function(row) {
              if(row.type=="group") {
                getStr(row.next)
              } else {
                str+=","+row.no
              }
            })
          }
          getStr(virtualDeviceList[0].next)
        }
        recursiveFunction()
        this.getList(str.slice(1))
      },
      getList (deviceNosStr) {
        historyApi.searchHistoryIndicationValue(deviceNosStr,this.datetimeValue[0],this.datetimeValue[1],respon => {
          this.tableList=respon
        })
      },
      //新历史示值以上
      compare (name) {
        return function(a,b) {
          var s1=a[name];
          var s2=b[name];
          return s1.localeCompare(s2);
        }
      },
      isGroup (item) {
        return item.hasOwnProperty('next')
      },
      autoSelectMethod (item) {
        return true
      },
      checkItemTwo (data) {
        if(data==undefined) {
          return []
        }
        this.nowCheckedItemName=data.name
        // 匹配选中项下所有的设备
        var deviceList=treeToList(copy(data),'next',item => {
          return item.hasOwnProperty("next")
        }).filter(item => {
          return item.entityName=="VirtualDevicePojo"
        })
        var nolist=deviceList.map(item => item.no).sort((a,b) => a-b)
        tcHistoryShowValueStore.commit('setdeviceNos',nolist.join(','))
        this.$dialogMethod.showLoading('正在加载')
      },
      // 导出报表
      exportReport () {
        var title=this.nowCheckedItemName+'历史示值表'
        this.$api.reportApi.exportHistoryIndicationValue(this.formData.deviceNos,this.formData.beginTime,this.formData.endTime,respon => {
          saveAs(DWSystemSetting.downloadUrl+'/'+respon,title+".xls")
        },respon => {
          this.$message({
            message: respon,
            type: 'error'
          });
        })
      },
    }
  }
</script>

<style scoped lang="scss">
  .tcHistoryShowValue {
    position: relative;
  }

  .new-tree {
    width: 2.65rem;
    min-width: 2.55rem;
    position: relative;
    transition: 0.5s;
    background-color: #fff;
    height: 96%;
  }

  .new-tree-active {
    width: 0;
    min-width: 0
  }

  /deep/.el-button {
    width: 0.15rem;
    position: relative;
    left: 60%;
    cursor: pointer;
    background-color: transparent;
    border: 0;
  }

  .elTree_hideButton1 {
    z-index: 500;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }

  .elTree_hideButton2 {
    z-index: 500;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }

  /deep/.el-tree {
    min-width: 2.55rem;
  }

  /deep/.el-scrollbar .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  /deep/.el-scrollbar__wrap .el-scrollbar__view {
    white-space: nowrap;
    display: inline-block;
  }


  .scroll {
    width: 100%;
    height: 100%;
  }

  .tcHistoryShowValue {
    display: flex;
  }

  .VirtualDeviceRTValue {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: white;
  }

  .VirtualDeviceRTValueRigth {
    width: 100%;
    height: 96%;
    /*overflow: hidden;*/
    /* padding-bottom: 55px; */
    /* margin-top: 10px; */
    background-color: white;
  }

  .virtualDeviceRTValueBody {
    width: 100%;
    display: flex !important;
    align-items: center;
    justify-content: space-between;
  }

  .buttonLine {
    position: relative;
    border-left: 1px solid #EBEEF5;
  }

  .totalPower {
    position: absolute;
    right: 1rem;
  }

  .totalPower p {
    font-size: 0.18rem !important;
  }

  .buttonLine>button {
    height: 32px;
    background-color: #409EFF;
    color: #FFFFFF;
    padding: 0 18px;
    margin-left: 10px;
    border-radius: 4px;
    flex-shrink: 0;
    cursor: pointer;
  }
</style>